/**
 * Non-error console methods that dump arbitrary values (including network-call
 * response bodies) to the browser console. These are silenced in production;
 * console.error and console.warn are always kept so real errors still surface.
 */
const NON_ERROR_CONSOLE_METHODS = ['log', 'debug', 'info'] as const;

/**
 * In production, replace console.log / console.debug / console.info with silent
 * no-ops so network-call responses and other debug output never reach the
 * browser console (and therefore never reach Ryn Replay's console capture).
 * console.error and console.warn are never touched, so genuine errors keep
 * surfacing (WI 31333).
 *
 * No-op in non-production so local debugging is unaffected. Called once per app
 * at bootstrap with the app's own `environment.production` flag; re-applying is
 * harmless.
 */
export function suppressNonErrorConsoleInProduction(
  isProduction: boolean
): void {
  if (!isProduction) {
    return;
  }

  const noop = (): void => {
    /* non-error console output is intentionally disabled in production */
  };

  for (const method of NON_ERROR_CONSOLE_METHODS) {
    (console as unknown as Record<string, () => void>)[method] = noop;
  }
}
